import React from 'react';
import { Card } from 'react-bootstrap';

/**
 * Skeleton placeholder for a chart card while data is loading or after navigation.
 * Renders a pulsing card with 12 horizontal lines mimicking bar-chart shape.
 * Used inside ChartCardWithPagination when `loading={true}`.
 */
export const ChartCardSkeleton = () => (
    <Card className="chart-card chart-card-skeleton">
        <Card.Body>
            {/* Skeleton headline row */}
            <div className="chart-skeleton-line chart-skeleton-sm" style={{ marginBottom: '1rem' }} />

            {/* Skeleton chart canvas – 12 bars for a monthly chart */}
            <div className="chart-skeleton-bars">
                {Array.from({ length: 12 }, (_, i) => (
                    <div
                        key={i}
                        className="chart-skeleton-bar"
                        style={{ animationDelay: (0.05 * i) + 's' }}
                    />
                ))}
            </div>

            {/* Skeleton axis labels */}
            <div className="chart-skeleton-line chart-skeleton-xs" style={{ marginTop: '0.75rem' }} />
        </Card.Body>
    </Card>
);
